import * as React from 'react'
import {SnackbarProvider, useSnackbar} from 'notistack'
import snackHandler from './SnackHandler'
import {Button} from '@mui/material'
import {messages} from '../texts'

interface SnackProps {
    children?: React.ReactNode
}

const Snack = (props: SnackProps) => {
    const {children} = props
    const {enqueueSnackbar, closeSnackbar} = useSnackbar()

    React.useEffect(() => {
        snackHandler.handle(not => {
            enqueueSnackbar(not.message, {
                variant: not.type,
                persist: not.persist,
                action: not.persist
                    ? key => (
                          <Button data-cy="snackbar-dismiss-button" color="inherit" onClick={() => closeSnackbar(key)}>
                              {messages.getText('snackHandler', 'dismiss')}
                          </Button>
                      )
                    : undefined
            })
        })

        return snackHandler.unhandle
    }, [enqueueSnackbar, closeSnackbar])

    return children
}

function SnackWrapper({children}: React.PropsWithChildren) {
    return (
        <SnackbarProvider maxSnack={4}>
            <Snack>{children}</Snack>
        </SnackbarProvider>
    )
}

export default SnackWrapper
